import './Notes.less';
import { CommonNotes } from '../../common';
import { JobItem } from 'domains/workspaceDomain';

const Notes = (jobDate: JobItem) => {
  return (
    <div className="notes-card">
      <CommonNotes {...jobDate} />
    </div>
  );
};

export default Notes;
